export const FETCH_PLANS = 'FETCH_PLANS';
export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS';
export const FETCH_PLANS_ERROR = 'FETCH_PLANS_WANT_ERROR';
export const FETCH_PARTICIPANT_PROFILE = 'FETCH_PARTICIPANT_PROFILE';
export const FETCH_PARTICIPANT_PROFILE_SUCCESS = 'FETCH_PARTICIPANT_PROFILE_SUCCESS';
export const FETCH_PARTICIPANT_PROFILE_ERROR = 'FETCH_PARTICIPANT_PROFILE_WANT_ERROR';
export const FETCH_RIX_COMPENSATION = 'FETCH_RIX_COMPENSATION';
export const FETCH_RIX_COMPENSATION_SUCCESS = 'FETCH_RIX_COMPENSATION_SUCCESS';
export const FETCH_RIX_COMPENSATION_ERROR = 'FETCH_RIX_COMPENSATION_ERROR';

export const fetchPlans = () => ({
  type: FETCH_PLANS,
});

export const fetchPlansSuccess = (payload: any) => ({
  type: FETCH_PLANS_SUCCESS,
  payload,
});

export const fetchPlansError = (payload: any) => ({
  type: FETCH_PLANS_ERROR,
  payload,
});

export const fetchParticipantProfile = (payload: any) => ({
  type: FETCH_PARTICIPANT_PROFILE,
  payload,
});

export const fetchParticipantProfileSuccess = (payload: any) => ({
  type: FETCH_PARTICIPANT_PROFILE_SUCCESS,
  payload,
});

export const fetchParticipantProfileError = (payload: any) => ({
  type: FETCH_PARTICIPANT_PROFILE_ERROR,
  payload,
});

export const fetchRixCompensation = (payload: any) => ({
  type: FETCH_RIX_COMPENSATION,
  payload,
});

export const fetchRixCompensationSuccess = (payload: any) => ({
  type: FETCH_RIX_COMPENSATION_SUCCESS,
  payload,
});
export const fetchRixCompensationError = (payload: any) => ({
  type: FETCH_RIX_COMPENSATION_ERROR,
  payload,
});
